import {Container, Paper, TableBody, TableHead} from "@mui/material";
import {
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import {GetEnumValueName} from "../../logic/EnumHelper";
import * as DataProvider from "../../logic/DataProvider";
import dayjs from "dayjs";


const AgreementsPage = () => {
    const [agreements, setAgreements] = useState([]);

    useEffect(() => {
        fetchAgreements();
    }, []);

    const fetchAgreements = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.agreements) {
                let agreements = bundle.agreements;
                setAgreements(JSON.parse(JSON.stringify(agreements)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={3}>Type</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={3}>Conclusion Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={3}>Termination Date</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {agreements && agreements.map((agreement) => (
                            <StyledTableBodyRow key={agreement.id}>
                                <StyledTableCell>{GetEnumValueName('brokerageAgreementType', agreement.type)}</StyledTableCell>
                                <StyledTableCell>{dayjs(agreement.conclusionDate).toDate().toDateString()}</StyledTableCell>
                                <StyledTableCell>{agreement.terminationDate === null ? '-' : dayjs(agreement.terminationDate).toDate().toDateString()}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default AgreementsPage;